import { SubscriptionLevel } from '@gtintel/platform-types';
export const team = {
  id: 1,
  name: 'Test team',
  subscription_level: SubscriptionLevel.Enterprise,
  type: 1,
  tags: [],
  tag_groups: [],
  num_members: 2,
  users: [{
    id: 2,
    url: 'http://localhost:8000/api/users/2/',
    first_name: 'Test',
    last_name: 'Client',
    email: 'dev.client@gtintel.io',
    phone: '',
    authy_id: '',
    company: 'Ground Truth Intelligence',
    street_address: '27 Dev Test Rd',
    apartment: '',
    tags: [],
    tag_groups: [{
      id: 1,
      name: 'Professional background',
      code: '1000',
      tags: []
    }],
    is_client: true,
    is_administrator: false,
    is_network_partner: false,
    accept_batch: false,
    timezone: 'America/New_York',
    is_active: true,
    full_name: 'Test Client',
    edit_role: false,
    is_auto_tag: true,
    is_deleted: false,
    team: {
      id: 1,
      name: 'Test team'
    },
    role: 1
  }, {
    id: 4,
    url: 'http://localhost:8000/api/users/4/',
    first_name: 'Test',
    last_name: 'Dual Account',
    email: 'dev.dual@gtintel.io',
    authy_id: '',
    company: 'Ground Truth Intelligence',
    street_address: '27 Dev Test Rd',
    tags: [],
    tag_groups: [],
    is_client: true,
    is_administrator: false,
    is_network_partner: false,
    accept_batch: false,
    timezone: 'America/New_York',
    dual_account: '4',
    is_active: true,
    full_name: 'Test Dual Account',
    edit_role: false,
    is_auto_tag: true,
    is_deleted: false,
    team: {
      id: 1,
      name: 'Test team'
    },
    role: 1,
    phone: ''
  }],
  company: {}
};
export const teamList = [{
  id: 1,
  name: 'Test team'
}];